import { render, staticRenderFns } from "./CreateBucketList.vue?vue&type=template&id=20634930&"
import script from "./CreateBucketList.vue?vue&type=script&lang=js&"
export * from "./CreateBucketList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports